import clsx from "clsx";

export const ComponentContainer = ({
  children,
  marginBottom,
  marginTop,
  dark,
  onBoarding,
  title,
}: {
  children: React.ReactNode;
  marginBottom?: string;
  marginTop?: string;
  dark?: boolean;
  onBoarding?: boolean;
  title?: JSX.Element | string;
}) => (
  <article
    className={clsx(
      "flex flex-col text-white w-full shadow-soft-dark-bottom justify-center border-t border-b border-l border-r rounded-lg mobile:rounded-none mobile:border-l-none mobile:border-r-none sb-v2-lg:border sb-v2-lg:rounded-lg border-white/10",
      marginBottom,
      marginTop,
      onBoarding && "z-21 shadow-white-glow pointer-events-none",
    )}
  >
    {title && (
      <div className="px-2 py-1 text-sm sb-v2-lg:rounded-t-lg bg-white/10">
        {title}
      </div>
    )}
    <div
      className={
        dark
          ? "bg-black/[0.7] p-2 rounded-lg"
          : "bg-white/[0.01] py-4 mobile:px-2 px-4 sb-v2-lg:px-4"
      }
    >
      {children}
    </div>
  </article>
);
